"use client";

import Image from "next/image";
import { CheckCircle } from "@phosphor-icons/react";
import { useTranslations } from "next-intl";

import { useModalInquiryContext } from "@/context/ModalInquiryContext";

const IMAGE_SRC =
	"/image/new-version/ValueAddedSolutions/assembly/we-flexibly-support-efficient-assembly-needs-across-scenarios-1.webp";

const NEEDS = ["needsItem1", "needsItem2", "needsItem3", "needsItem4", "needsItem5", "needsItem6"] as const;

export default function AssemblyNeeds() {
	const t = useTranslations("new-assembly");
	const { openModalInquiry } = useModalInquiryContext();

	return (
		<section className="bg-[#eeeeee] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 sm:mb-8 md:mb-10">
					<h2 className="inline-block text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						<span className="block">{t("needsTitleLine1")}</span>
						<span className="mt-1 flex items-end gap-4">
							<span>{t("needsTitleLine2")}</span>
							<span className="mb-1 h-[3px] w-20 bg-themePrimary400 sm:w-28 md:w-36" aria-hidden="true" />
						</span>
					</h2>
				</header>

				<div className="grid items-center gap-8 lg:grid-cols-[1fr_1.05fr] lg:gap-14">
					<div className="relative aspect-[4/4.5] w-full overflow-hidden bg-white">
						<Image
							src={IMAGE_SRC}
							alt={t("needsImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 48vw"
						/>
					</div>

					<div className="">
						<p className="mb-6 text-sm leading-relaxed text-black md:mb-8 md:text-base">{t("needsDesc")}</p>
						<h3 className="mb-4 text-lg font-bold text-black sm:text-xl md:text-2xl">
							{t("needsListTitle")}
						</h3>
						<ul className="space-y-4 sm:space-y-5">
							{NEEDS.map((item) => (
								<li key={item} className="text-sm leading-relaxed text-black md:text-base">
									<CheckCircle
										className="mr-3 inline-block h-5 w-5 align-[-3px] text-themePrimary400 sm:h-6 sm:w-6 sm:align-[-5px]"
										weight="fill"
										aria-hidden="true"
									/>
									{t(item)}
								</li>
							))}
						</ul>
						<button
							type="button"
							onClick={openModalInquiry}
							className="mt-7 inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-[#83b751] md:mt-9 md:px-8 md:py-3.5 md:text-base"
						>
							{t("needsGetInstantQuote")}
						</button>
					</div>
				</div>
			</div>
		</section>
	);
}
